export default __webpack_public_path__ + "58f00f48c9cca2df4e774e0b53abbaeb.svg";